export const consignmentStatusPrettyNameMapping = {
  attempted: 'Undelivered',
  reachedathub: 'Reached At Hub',
  on_hold: 'On Hold',
  fts: 'FTS',
  'hub-to-hub': 'Hub To Hub',
  rto: 'RTO',
  inscan_at_hub: 'Inscan At Hub',
  inscan_at_origin_hub: 'Inscan At Origin Hub',
  cancelled: 'Cancelled',
  intransittohub: 'In Transition To Hub',
  outfordelivery: 'Out for Delivery',
  pickup_completed: 'Pickup Completed',
  created: 'Created',
  accept: 'Accept',
  in_transit: 'In Transit',
  archived: 'Archived',
  delivered: 'Delivered',
  softdata_upload: 'Softdata Upload',
  tracking_pending: 'Tracking Pending',
  bagged: 'Bagged',
  booked_at_hub: 'Booked At Hub',
  delivery: 'Delivery',
  not_picked_up: 'Not Picked Up',
  out_for_pickup: 'Out for Pickup',
  pickup_awaited: 'Pickup Awaited',
  pickup_scheduled: 'Pickup Scheduled',
  rts_initiated: 'RTS Initiated',
  rto_initiated: 'RTO Initiated',
  rto_in_transit: 'RTO in Transit',
  rto_delivered: 'RTO Delivered',
  lost: 'Lost',
  shelved: 'Shelved',
  rescheduled: 'Rescheduled',
  received: 'Received',
  not_received: 'Not Received',
  out_for_store_pickup: 'Out for Store Pickup',
  loaded: 'Loaded',
  sealed: 'Sealed',
  departed: 'Departed',
  intransit_to_hub: 'In Transit',
  outscan_at_hub: 'Outscan',
  loading: 'Loading',
  all_consignment_received: 'All CNs Received',
  debagged: 'Debagged',
  added_to_ist: 'Added to IST',
  received_against_ist: 'Received Against IST',
  inscan_at_gateway: 'Inscan At Gateway',
  mark_clearance_at_origin: 'Marked Clearance At Origin',
  mark_clearance_at_destination: 'Marked Clearance At Destination',
  handover_courier_partner: 'Handover Carrier Partner',
  assign_courier_partner: 'Assign Carrier Partner',
  receive_shipments_in_gateway: 'Receive shipments in the gateway',
  pending_custom: 'Pending custom',
  shipment_clear_successfully: 'Shipment clear successfully',
  shipment_not_clear: 'Shipment not clear',
  inscan_at_planning_hub: 'Inscan At Planning Hub',
  manifest_submitted: 'Manifest Submitted',
  manifest_rejected: 'Manifest Rejected',
  manifest_accepted: 'Manifest Accepted',
  declaration_submitted: 'Declaration Submitted',
  declaration_rejected: 'Declaration Rejected',
  declaration_accepted: 'Declaration Accepted',
  approval_pending: 'Approval Pending',
  archive_created: 'Archive Created',
  archive_submitted: 'Archive Submitted',
  archive_rejected: 'Archive Rejected',
  archive_saved: 'Archive Saved',
  archive_sent: 'Archive Sent',
  pdf_submitted: 'PDF Submitted',
  rejected: 'Rejected',
  rvp_delivered: 'RVP Delivered',
  exception: 'Exception',
  deps_exception: 'DEPS',
};
export function getPrettyStatusCustomerActivity(status) {
  const mapping = {
    success: 'Delivered',
    attempted: 'Attempted',
    reachedathub: 'Reached At Hub',
    on_hold: 'On Hold',
    fts: 'FTS',
    'hub-to-hub': 'Hub To Hub',
    rto: 'RTO',
    inscan_at_hub: 'Inscan At Hub',
    inscan_at_origin_hub: 'Inscan At Origin Hub',
    cancelled: 'Cancelled',
    intransittohub: 'In Transition To Hub',
    intransit_to_hub: 'In Transition To Hub',
    outfordelivery: 'Out for Delivery',
    pickup_completed: 'Pickup Completed',
    created: 'Created',
    accept: 'Accept',
    in_transit: 'In Transit',
    archived: 'Archived',
    delivered: 'Delivered',
    softdata_upload: 'Softdata Upload',
    outscan_at_hub: 'Outscan at hub',
    added_to_ist: 'Added to IST',
    sealed: 'Sealed',
    deist: 'De-IST',
    tracking_pending: 'Tracking Pending',
    bagged: 'Bagged',
    booked_at_hub: 'Booked At Hub',
    delivery: 'Delivery',
    not_picked_up: 'Not Picked Up',
    out_for_pickup: 'Out for Pickup',
    pickup_awaited: 'Pickup Awaited',
    pickup_scheduled: 'Pickup Scheduled',
    rts_initiated: 'RTS Initiated',
    rto_initiated: 'RTO Initiated',
    rto_in_transit: 'RTO in Transit',
    rto_delivered: 'RTO Delivered',
    rvp_delivered: 'RVP Delivered',
    exception: 'Exception',
  };
  return mapping[status];
}

export function getConsignmentStatusPrettyName(status) {
  return consignmentStatusPrettyNameMapping[status]
    ? consignmentStatusPrettyNameMapping[status]
    : status;
}

export const retailConsignmentStatus = {
  reachedathub: 'Reached at hub',
  outfordelivery: 'Out for delivery',
  delivered: 'Delivered',
  attempted: 'Undelivered',
  pickup_awaited: 'Pickup Awaited',
  pickup_scheduled: 'Pickup Scheduled',
  out_for_pickup: 'Out For Pickup',
  not_picked_up: 'Not Picked Up',
  pickup_completed: 'Pickup Completed',
  inscan_at_hub: 'Inscan at Hub',
  intransittohub: 'In Transit to Hub',
  intransit_to_hub: 'In Transit to Hub',
  received: 'Received',
  not_received: 'Not Received',
  out_for_store_pickup: 'Out for Store Pickup',
  loaded: 'Loaded',
  on_hold: 'On Hold',
  rto: 'RTO',
  rvp_delivered: 'RVP Delivered',
  deps_exception: 'DEPS',
};
export const tripStatus = {
  created: 'Created',
  assigned: 'Assigned',
  started: 'Started',
  completed: 'Completed',
};
export const tripType = {
  endpoint: 'Local',
};
export function getRetailConsignmentStatus(status) {
  const statusValue = retailConsignmentStatus[status] ? retailConsignmentStatus[status] : status;
  return statusValue;
}
// For In trip Status calculation
// consignment_type: null
// task_status: 'success', Pretty name: 'Delivered'
// task_status: 'attempted', Pretty name: 'Attempted'

// consignment_type: 'reverse'
// task_status: 'success', Pretty name: 'Pickup Completed'
// task_status: 'attempted', Pretty name: 'Not Picked Up'
export function getRetailInTripConsignmentStatus(record): any {
  if (!record.consignment_type) {
    if (record.task_status === 'success') {
      return {
        status: record.task_type === 'single_consignment_pickup' ? 'Pickup Completed' : 'Delivered',
        time: record.task_completion_time,
      };
    }
    if (record.task_status === 'attempted') {
      return {
        status: record.task_type === 'single_consignment_pickup' ? 'Not Picked Up' : 'Undelivered',
        time: record.task_completion_time,
      };
    }
    return { status: getRetailConsignmentStatus(record.status), time: record.last_main_event_time };
  }
  if (record.consignment_type === 'reverse') {
    if (record.task_status === 'success') {
      return { status: 'Pickup Completed', time: record.task_completion_time };
    }
    if (record.task_status === 'attempted') {
      return { status: 'Not Picked Up', time: record.task_completion_time };
    }
    return { status: getRetailConsignmentStatus(record.status), time: record.last_main_event_time };
  }
  if (record.consignment_type === 'pickupanddelivery') {
    if (record.task_status === 'success') {
      return {
        status: record.task_type === 'store_consignment_pickup' ? 'Pickup Completed' : 'Delivered',
        time: record.task_completion_time,
      };
    }
    if (record.task_status === 'attempted') {
      return {
        status: record.task_type === 'store_consignment_pickup' ? 'Not Picked Up' : 'Undelivered',
        time: record.task_completion_time,
      };
    }
    return { status: getRetailConsignmentStatus(record.status), time: record.last_main_event_time };
  }
  if (record.consignment_type === 'pickupanddeliveryreverse') {
    if (record.task_status === 'success') {
      return {
        status: record.task_type === 'single_consignment_pickup' ? 'Pickup Completed' : 'Received',
        time: record.task_completion_time,
      };
    }

    if (record.task_status === 'attempted') {
      return {
        status: record.task_type === 'single_consignment_pickup' ? 'Not Picked Up' : 'Not Received',
        time: record.task_completion_time,
      };
    }

    return { status: getRetailConsignmentStatus(record.status), time: record.last_main_event_time };
  }
  if (!record.consignment_type || record.consignment_type === 'replacement') {
    if (record.task_status === 'success') {
      return { status: 'Delivered', time: record.task_completion_time };
    }
    if (record.task_status === 'attempted') {
      return { status: 'Undelivered', time: record.task_completion_time };
    }
    return { status: getRetailConsignmentStatus(record.status), time: record.last_main_event_time };
  }
  return { status: getRetailConsignmentStatus(record.status), time: record.last_main_event_time };
}
export function tripStatusPrettyNames(key) {
  const value = tripStatus[key];
  return value || key;
}
